module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_14-292e87450e113688b4cd57381a71b9cd.png";